import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type UserState = {
  id?: string;
  email?: string;
  first_name?: string;
  last_name?: string;
  user_type?: string;
  is_email_verified?: boolean;
  auth_provider?: string;
  avatar?: string;
  phone_number?: string;
  dob?: string;
  gender?: string;
}

const initialState: UserState = {
  id: '',
  email: '',
  first_name: '',
  last_name: '',
  user_type: 'USER',
  is_email_verified: false,
  auth_provider: 'cognito',
  avatar: '',
  phone_number: '',
  dob: '',
  gender: '',
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<UserState>) {
      if (action.payload?.id !== undefined) state.id = action.payload.id
      if (action.payload?.email !== undefined) state.email = action.payload.email
      if (action.payload?.first_name !== undefined) state.first_name = action.payload.first_name
      if (action.payload?.last_name !== undefined) state.last_name = action.payload.last_name
      if (action.payload?.user_type !== undefined) state.user_type = action.payload.user_type
      if (action.payload?.is_email_verified !== undefined) state.is_email_verified = action.payload.is_email_verified
      if (action.payload?.auth_provider !== undefined) state.auth_provider = action.payload.auth_provider
      if (action.payload?.avatar !== undefined) state.avatar = action.payload.avatar
      if (action.payload?.phone_number !== undefined) state.phone_number = action.payload.phone_number
      if (action.payload?.dob !== undefined) state.dob = action.payload.dob
      if (action.payload?.gender !== undefined) state.gender = action.payload.gender
    },
    updateUserProfile(state, action: PayloadAction<Partial<UserState>>) {
      if (action.payload?.id !== undefined) state.id = action.payload.id
      if (action.payload?.email !== undefined) state.email = action.payload.email
      if (action.payload?.first_name !== undefined) state.first_name = action.payload.first_name
      if (action.payload?.last_name !== undefined) state.last_name = action.payload.last_name
      if (action.payload?.user_type !== undefined) state.user_type = action.payload.user_type
      if (action.payload?.is_email_verified !== undefined) state.is_email_verified = action.payload.is_email_verified
      if (action.payload?.auth_provider !== undefined) state.auth_provider = action.payload.auth_provider
      if (action.payload?.avatar !== undefined) state.avatar = action.payload.avatar
      if (action.payload?.phone_number !== undefined) state.phone_number = action.payload.phone_number
      if (action.payload?.dob !== undefined) state.dob = action.payload.dob
      if (action.payload?.gender !== undefined) state.gender = action.payload.gender
    },
    setUserVerificationStatus(state, action: PayloadAction<boolean>) {
      state.is_email_verified = action.payload
    },
    clearUser(state) {
      state.id = ''
      state.email = ''
      state.first_name = ''
      state.last_name = ''
      state.user_type = 'USER'
      state.is_email_verified = false
      state.auth_provider = 'cognito'
      state.avatar = ''
      state.phone_number = ''
      state.dob = ''
      state.gender = ''
    },
  },
});

export const {
  setUser,
  updateUserProfile,
  setUserVerificationStatus,
  clearUser,
} = userSlice.actions;

export default userSlice.reducer;
